import React, { ReactNode } from 'react';
import {
  CommonDEFS,
  DeepFieldPQOIcon,
  DeepFieldSRIcon,
  PulsarAV1Icon,
  PulsarAVIFIcon,
  PulsarVQMIcon,
} from 'components/NewHeader/HeaderNavIcons';
import styled from 'styled-components';
import {
  BBPALE,
  BodyTextMStrong,
  BodyTextS,
  BodyTextSStrong,
  GRAY30,
  GRAY60,
  GRAY90,
} from 'global-styles';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { opacityAppear } from 'components/Home';

type ProductItem = {
  label: string;
  Icon: ReactNode;
  features: { [key in 'ko' | 'en']: string[] };
  href: string;
};
const ProductNavList = () => {
  const { locale } = useRouter();
  const deepFieldItems: ProductItem[] = [
    {
      label: 'DeepField-SR',
      Icon: <DeepFieldSRIcon />,
      href: '/product/sr',
      features: { ko: ['AI', '업스케일링', '4K'], en: ['AI', 'Upscale', '4K'] },
    },
    {
      label: 'DeepField-PQO',
      Icon: <DeepFieldPQOIcon />,
      href: '/product/pqo',
      features: {
        ko: ['AI', '압축 코덱', '화질개선'],
        en: ['AI', 'Codec', 'Imporved'],
      },
    },
  ];

  const pulsarItems: ProductItem[] = [
    {
      label: 'Pulsar-AV1',
      Icon: <PulsarAV1Icon />,
      href: '/product/av1',
      features: {
        ko: ['반도체', '영상 압축', '인코더'],
        en: ['Hardware', 'Video', 'Encoder'],
      },
    },
    {
      label: 'Pulsar-AVIF',
      Icon: <PulsarAVIFIcon />,
      href: '/product/avif',
      features: {
        ko: ['반도체', '이미지 압축', '인코더'],
        en: ['Hardware', 'Image', 'Encoder'],
      },
    },
    {
      label: 'Pulsar-VQM',
      Icon: <PulsarVQMIcon />,
      href: '/product/vmaf',
      features: {
        ko: ['VMAF', '품질측정', '비용절감'],
        en: ['VMAF', 'Measure', 'Costsave'],
      },
    },
  ];

  return (
    <ProductNavListContainer>
      <BodyTextSStrong className="p-category">DeepField</BodyTextSStrong>
      <ul>
        {deepFieldItems.map(item => (
          <li className="nav-item" key={item.label}>
            <Link href={item.href}>
              <a>
                <span className="icon-wrapper">{item.Icon}</span>
                <BodyTextMStrong>{item.label}</BodyTextMStrong>
              </a>
            </Link>

            <ul className="feat-ul">
              {item.features[locale].map(feature => (
                <BodyTextS
                  as="li"
                  className="feat-li"
                  key={item.label + feature}
                >
                  #{feature}
                </BodyTextS>
              ))}
            </ul>
          </li>
        ))}
      </ul>

      <BodyTextSStrong className="p-category pp">Pulsar</BodyTextSStrong>
      <ul>
        {pulsarItems.map(item => (
          <li className="nav-item" key={item.label}>
            <Link href={item.href}>
              <a>
                <span className="icon-wrapper">{item.Icon}</span>
                <BodyTextMStrong>{item.label}</BodyTextMStrong>
              </a>
            </Link>

            <ul className="feat-ul">
              {item.features[locale].map(feature => (
                <BodyTextS
                  as="li"
                  className="feat-li"
                  key={item.label + feature}
                >
                  #{feature}
                </BodyTextS>
              ))}
            </ul>
          </li>
        ))}
      </ul>
      <CommonDEFS />
    </ProductNavListContainer>
  );
};

export default ProductNavList;

const ProductNavListContainer = styled.div`
  animation: ${opacityAppear} 0.15s ease-in;

  & a {
    display: flex;
    align-items: center;
    color: ${GRAY30};
    gap: 16px;
  }
  & > ul {
    display: flex;
  }
  & .nav-item {
    padding: 16px;
    padding-bottom: 0;
  }
  & .nav-item:hover {
    transition: background 0.3s;
    border-radius: 16px;
    background: ${BBPALE};
  }
  & .nav-item {
    width: 280px;
  }
  .p-category {
    color: ${GRAY60};
    display: block;
    margin-bottom: 16px;
  }
  .pp {
    margin-top: 16px;
  }
  .feat-ul {
    display: flex;
    gap: 8px;
    padding-block: 16px;
    white-space: nowrap;
  }
  .feat-li {
    padding: 4px 12px;
    color: ${GRAY60};
    border: 1px solid ${GRAY90};
    border-radius: 18px;
  }
  .icon-wrapper {
    width: 48px;
    height: 48px;
    display: inline-block;
  }
`;
